import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  addRow: {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'flex-end',
  },
  sendButton: {
    flexShrink: 0,
  },
}))

export default useStyles
